import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

const Spinner = ({ size, style }) => {
  return (
    <div className="containerSpinner" style={style}>
      <div className="spinner">
        <FontAwesomeIcon icon="spinner" size={size} spin />
      </div>
    </div>
  );
};

export default Spinner;
